module.exports = __webpack_public_path__ + "img/step-7.bef775b1.jpg";